module.exports = __webpack_public_path__ + "static/img/common.b2be474.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/common.png
// module id = 6nni
// module chunks = 7